// extracted by mini-css-extract-plugin
module.exports = {"button":"LinkButton_button__2Rnrc"};